import * as yup from 'yup';
import { useMemo } from 'react';
import useScope from '../../Scope/Hooks/useScope';
import useTranslation from '../../../Hooks/useTranslation';

export default function useMedicalReportValidation() {
	const { isHungary } = useScope();
	const { t } = useTranslation();

	const validationSchema = useMemo(() => {
		if (isHungary) {
			return yup.object().shape({
				title: yup.string().required(),
				status: yup
					.string()
					.required('validation.medicalReportHungaryFields.status'),
				suggestion: yup
					.string()
					.required('validation.medicalReportHungaryFields.suggestion'),
				prescription: yup
					.string()
					.required('validation.medicalReportHungaryFields.prescription'),
				contactSpecialist: yup.boolean().notRequired(),
				diagnoses: yup
					.array()
					.of(
						yup.object().shape({
							diagnose: yup.object().shape({
								label: yup
									.string()
									.typeError(
										t('validation.medicalReportDetail.diagnosis') ?? '',
									),
								value: yup
									.string()
									.typeError(
										t('validation.medicalReportDetail.diagnosis') ?? '',
									)
									.required('validation.medicalReportDetail.diagnosis'),
							}),
						}),
					)
					.required(),
				text: yup.string().required('validation.medicalReportDetail.text'),
			});
		}

		return yup.object().shape({
			title: yup.string().required(),
			contactSpecialist: yup.boolean().notRequired(),
			diagnoses: yup
				.array()
				.of(
					yup.object().shape({
						diagnose: yup.object().shape({
							label: yup
								.string()
								.typeError(t('validation.medicalReportDetail.diagnosis') ?? ''),
							value: yup
								.string()
								.typeError(t('validation.medicalReportDetail.diagnosis') ?? '')
								.required('validation.medicalReportDetail.diagnosis'),
						}),
					}),
				)
				.required(),
			text: yup.string().required('validation.medicalReportDetail.text'),
		});
	}, []);

	return { validationSchema };
}
